import React from "react";
import { useLang } from "@/context/LangContext";

export const StatusDot = ({ status, size = 10 }) => {
  const color = status === "open" ? "#4CAF50" : status === "warn" ? "#FFC107" : "#F44336";
  return (
    <span
      data-testid={`status-dot-${status}`}
      aria-label={status}
      className="inline-block rounded-full flex-shrink-0"
      style={{ width: size, height: size, background: color, boxShadow: `0 0 0 3px ${color}22` }}
    />
  );
};

const StatusBadge = ({ status }) => {
  const { t } = useLang();
  const label = status === "open" ? t("status_open") : status === "warn" ? t("status_warn") : t("status_closed");
  return (
    <span
      data-testid={`status-badge-${status}`}
      className="inline-flex items-center gap-2 px-3 py-1 rounded-sm bg-grafite/5 text-xs font-medium text-grafite"
    >
      <StatusDot status={status} />
      {label}
    </span>
  );
};

export default StatusBadge;
